import { Box, FormControl, TextField } from "@mui/material";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

import { default as React } from "react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    command: {
      borderSize: 3,
      marginBottom: 15,
    },
    runButton: {
      // marginRight: 10,
    },
    commandHead: {
      backgroundColor: "rgba(0, 0, 0, .1)",
    },
    commandTitle: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(30),
    },
    commandContent: {
      display: "block",
      borderTop: "1px solid rgba(0, 0, 0, 0.12);",
      padding: "5px 16px",
    },
    formControl: {
      margin: theme.spacing(1),
      marginLeft: 0,
      marginRight: 0,
      width: "100%",
    },
    optionGroup: {
      background: "white",
    },
    chips: {},
    chip: {},
  })
);

export function CommandDefault(props) {
  const classes = useStyles();
  const { value, handleChange } = props;

  const handleChangeParams = (event: any) => {
    handleChange(event.target.value);
  };

  return (
    <>
      <Box component="p">
        <b>Внимание!</b> Накосячить очень просто! По возможности, используйте
        команды ниже.
      </Box>

      <FormControl className={classes.formControl}>
        <TextField
          id="params"
          label="Параметры команды"
          margin="dense"
          multiline
          minRows={5}
          fullWidth
          value={value}
          onChange={handleChangeParams}
        />
      </FormControl>
    </>
  );
}
